export const PUBLIC_VIEWER_DATA_ROOM_COMPANYID = "viewed-data-room-company-id";
export const PUBLIC_VIEWER_DATA_ROOM_ID = "viewed-data-room-id";
